import { render, staticRenderFns } from "./InvoiceAffixSettings.vue?vue&type=template&id=7bc5e5cc&scoped=true&"
import script from "./InvoiceAffixSettings.vue?vue&type=script&lang=js&"
export * from "./InvoiceAffixSettings.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAffixSettings.vue?vue&type=style&index=0&id=7bc5e5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5e5cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc5e5cc')) {
      api.createRecord('7bc5e5cc', component.options)
    } else {
      api.reload('7bc5e5cc', component.options)
    }
    module.hot.accept("./InvoiceAffixSettings.vue?vue&type=template&id=7bc5e5cc&scoped=true&", function () {
      api.rerender('7bc5e5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Tabs/InvoiceAffixSettings.vue"
export default component.exports